/**
 * Bagisto admin blades register Vue components in @stack('scripts') before
 * the Vite admin bundle runs. This stub queues those registrations.
 */
export function flushVueDeferredRegistry(Vue) {
  const pending = window.__lgfVueDeferredRegistry;

  if (!pending) {
    return;
  }

  if (pending.config) {
    if (pending.config.ignoredElements?.length) {
      Vue.config.ignoredElements = [
        ...(Vue.config.ignoredElements || []),
        ...pending.config.ignoredElements,
      ];
    }

    Object.keys(pending.config).forEach(key => {
      if (key !== 'ignoredElements') {
        Vue.config[key] = pending.config[key];
      }
    });
  }

  pending.components.forEach(({ name, definition }) => {
    Vue.component(name, definition);
  });

  delete window.__lgfVueDeferredRegistry;
}
